import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgQuestionCircleMid = function SvgQuestionCircleMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM2 12C2 6.47716 6.47716 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM11.25 8.5C10.8358 8.5 10.5 8.83579 10.5 9.25C10.5 9.66421 10.1642 10 9.75 10C9.33579 10 9 9.66421 9 9.25C9 8.00735 10.0074 7 11.25 7H12.4587C13.8622 7 15 8.13779 15 9.54132C15 10.3909 14.5754 11.1845 13.8684 11.6558L13.3067 12.0303C12.9589 12.2621 12.75 12.6524 12.75 13.0704V13.25C12.75 13.6642 12.4142 14 12 14C11.5858 14 11.25 13.6642 11.25 13.25V13.0704C11.25 12.151 11.7095 11.2923 12.4746 10.7822L13.0363 10.4078C13.3259 10.2147 13.5 9.88949 13.5 9.54132C13.5 8.96621 13.0338 8.5 12.4587 8.5H11.25ZM11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16Z"
  })));
};

export { SvgQuestionCircleMid as ReactComponent };
//# sourceMappingURL=question-circle-mid.svg.js.map
